module.exports = __webpack_public_path__ + "static/img/banner9.61ad0cbe.png";